import React from 'react';
import styled from 'styled-components';
import ShadowRender from 'components/shadow-render';
import Section from './section';

const Wrapper = styled.div`
  display: grid;
  gap: 15px;
`;

const Content = styled.div`
  all: initial;
  font-size: 14px;
  font-family: sans-serif;
  line-height: 1.2;
  word-break: break-word;
  p {
    margin: 0;
  }
  ul {
    padding-left: 1.5em !important;
    list-style-type: disc !important;
    list-style-position: inside;
    > li {
      list-style-type: disc !important;
      list-style-position: inside;
    }
  }
`;

export default ({ location }) => {
  if (!location?.aptlyListings?.benefits) return <></>;
  return (
    <Section>
      <Wrapper>
        <Content>
          <ShadowRender html={location?.aptlyListings?.benefits} />
        </Content>
      </Wrapper>
    </Section>
  );
};
